/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdNavbarProps } from './type';

export const navbarDefaultProps: TdNavbarProps = { animation: true, fixed: true, leftIcon: false, visible: true };
